/*
 * @Author: CYX
 * @Date: 2020-07-09 17:45:13
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 17:56:29
 */ 
export const serviceListEn = {
    hengyemingc: "firm name：",
    fuwulb: "Service category：",
    diquorguojia: "Region/country：",
    chukozhichi: "Product testing and certification services for export to the Middle East, supported exclusively by RACS&TAM.",
    pingjia: "evaluate",
    xiaoliang: "sales volume",
    jiage: "price",
    zixuncs: "Consulting the number",
}


// WEBPACK FOOTER //
// ./src/lang/home/serviceList/serviceListEn.js